export const STAFF_MANAGE_USER = 'STAFF_MANAGE_USER'
export const STAFF_MANAGE_TOKEN = 'STAFF_MANAGE_TOKEN'
export const STAFF_MANAGE_LOCALE = 'STAFF_MANAGE_LOCALE'
export const STAFF_MANAGE_TRANSALATION = 'STAFF_MANAGE_TRANSALATION'

// Map constants
export const MAP_GL_COLORS = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
    '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9',
    '#F8C471', '#82E0AA', '#F1948A', '#85C1E9', '#D7BDE2'
];

export const MAP_DEFAULT_CENTER = {
    longitude: 10.4515, // Germany default (Berlin)
    latitude: 51.1657,
    zoom: 6
};

export const MAP_STYLE = {
    version: 8,
    sources: {
        'osm-tiles': {
            type: 'raster',
            tiles: [
                'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
            ],
            tileSize: 256,
            attribution: '© OpenStreetMap contributors'
        }
    },
    layers: [
        {
            id: 'osm-tiles',
            type: 'raster',
            source: 'osm-tiles'
        }
    ]
};

export const ROLE = {
    1: 'Admin',
    20: 'Quản lý khu vực',
    21: 'Phó quản lý khu vực',
    22: 'QS',
    23: 'Quản lý vùng cấp cao',
    30: 'Quản lý vùng',
    40: 'Trợ lý vùng',
    60: 'Quản lý shop',
    70: 'Nhân viên',
    80: 'Springer',
}

export const roles = {
    admin: 1,
    regionManager: 20,
    viceRegionManager: 21,
    qs: 22,
    seniorAreaManager: 23,
    departmentManager: 30,
    areaManager: 40,
    shopManager: 50,
    staffShop: 60,
    staff: 70,
    springer: 80,
}

export const roleKeys = {
    1: 'admin',
    20: 'regionManager',
    21: 'viceRegionManager',
    22: 'qs',
    23: 'seniorAreaManager',
    30: 'departmentManager',
    40: 'areaManager',
    60: 'shopManager',
    70: 'employee',
    80: 'springer',
}

export const typesTimesheet = {
    work: 1,
    sick: 2,
    absence: 3,
    notWork: 4,
}

export const typesTimesheetLabel = {
    [typesTimesheet.work]: 'work',
    [typesTimesheet.sick]: 'sick',
    [typesTimesheet.absence]: 'absence',
    [typesTimesheet.notWork]: 'notWork',
}

export const cabinetData = [
    {
        value: 0,
        label: '0'
    },
    {
        value: 1,
        label: '1'
    },
    {
        value: 2,
        label: '2'
    },
]
export const MAKI_IGD = 1;
export const FUTO_IGD = 2;
export const NIGIRI_IGD = 3;
export const CALI_IGD = 4;
export const XL_IGD = 5;
export const BOWL_IGD = 6;
export const WRAP_IGD = 7;
export const SUMMER_ROLL_IGD = 8;
export const ingredientOptions = [
    {
        value: MAKI_IGD,
        label: 'maki',
    },
    {
        value: FUTO_IGD,
        label: 'futo',
    },
    {
        value: NIGIRI_IGD,
        label: 'nigiri',
    },
    {
        value: CALI_IGD,
        label: 'california',
    },
    {
        value: XL_IGD,
        label: 'xl',
    },
    {
        value: BOWL_IGD,
        label: 'bowl',
    },
    {
        value: WRAP_IGD,
        label: 'wrap',
    },
    {
        value: SUMMER_ROLL_IGD,
        label: 'summerRoll',
    },
]

export const MAKI_BOX = 1;
export const CALI_BOX = 2;
export const FUTO_BOX = 3;
export const SM_BOX = 4;
export const MD_BOX = 5;
export const LG_BOX = 6;
export const NIGIRI_BOX = 7;
export const ORDER_BOX = 8;
export const MAIN_BOX = 9;
export const SNACKS_BOX = 10;
export const DESERTS_BOX = 11;
export const RUECK_BOX = 12;
export const boxOptions = [
    {
        value: MAKI_BOX,
        label: 'maki',
    },
    {
        value: CALI_BOX,
        label: 'california',
    },
    {
        value: FUTO_BOX,
        label: 'futo',
    },
    {
        value: SM_BOX,
        label: 'small',
    },
    {
        value: MD_BOX,
        label: 'medium',
    },
    {
        value: LG_BOX,
        label: 'large',
    },
    {
        value: NIGIRI_BOX,
        label: 'nigiriBox',
    },
    {
        value: ORDER_BOX,
        label: 'orderBox',
    },
    {
        value: MAIN_BOX,
        label: 'mainBox',
    },
    {
        value: SNACKS_BOX,
        label: 'snacksBox',
    },
    {
        value: DESERTS_BOX,
        label: 'desertsBox',
    },
    {
        value: RUECK_BOX,
        label: 'rueckBox',
    },
]

export const orderBoxStatus = [
    {
        value: 0,
        label: 'plannedOrder',
        color: 'gold'
    },
    {
        value: 1,
        label: 'doneOrder',
        color: '#87d068',
    },
    {
        value: 2,
        label: 'cancelOrder',
        color: 'error',
    },
]

export const langNotifications = [
    { value: 'de', label: 'german' },
    { value: 'en', label: 'english' },
    { value: 'vi', label: 'vietnamese' },
    { value: 'ja', label: 'japanese' },
    { value: 'ko', label: 'korean' },
    { value: 'th', label: 'thai' },
    { value: 'my', label: 'myanmar' },
]

export const CHATBOT_VOICE_SETTINGS = {
    'vi': {
        language: "vi-VN",
        voiceNames: [
            "Microsoft An - Vietnamese (Vietnam)",
            "Google Tiếng Việt",
            "Vietnamese Female",
            "Vietnamese Male"
        ],
        rate: 1.0,
        pitch: 1.0,
        volume: 1.0
    },
    'en': {
        language: "en-US",
        voiceNames: [
            "Google US English",
            "Microsoft David - English (United States)",
            "Alex",
            "Samantha"
        ],
        rate: 1.0,
        pitch: 1.0,
        volume: 1.0
    },
    'de': {
        language: "de-DE",
        voiceNames: [
            "Google Deutsch",
            "Microsoft Katja - German (Germany)",
            "Anna"
        ],
        rate: 0.9,
        pitch: 1.0,
        volume: 1.0
    },
    'ja': {
        language: "ja-JP",
        voiceNames: [
            "Google 日本語",
            "Microsoft Ayumi - Japanese (Japan)",
            "Kyoko"
        ],
        rate: 0.9,
        pitch: 1.1,
        volume: 1.0
    },
    'ko': {
        language: "ko-KR",
        voiceNames: [
            "Google 한국의",
            "Microsoft Heami - Korean (Korea)",
            "Yuna"
        ],
        rate: 0.9,
        pitch: 1.0,
        volume: 1.0
    },
    'th': {
        language: "th-TH",
        voiceNames: [
            "Google ไทย",
            "Microsoft Achara - Thai (Thailand)",
            "Kanya"
        ],
        rate: 0.8,
        pitch: 1.0,
        volume: 1.0
    },
    'my': {
        language: "my-MM",
        voiceNames: [
            "Google မြန်မာ",
            "Myanmar Female",
            "Myanmar Male"
        ],
        rate: 0.8,
        pitch: 1.0,
        volume: 1.0
    }
}

// Helper function to get voice settings by language
export const getChatbotVoiceSettings = (languageCode = 'vi') => {
    return CHATBOT_VOICE_SETTINGS[languageCode] || CHATBOT_VOICE_SETTINGS['vi'];
}

export const JOB_PENDING = 'pending';
export const JOB_PROCESSING = 'processing';
export const JOB_COMPLETED = 'completed';
export const JOB_FAILED = 'failed';
